import { isBrowser } from "./Browser";
import { getProfile, saveProfile } from "api.mjs";
import log from 'loglevel';


let profile = null;
let receiveEmail = null;

export const isReceivingEmails = () => {
  return receiveEmail;
}

export const setReceivingEmails = (shouldReceiveEmails, sessionContext) => {
  receiveEmail = shouldReceiveEmails;
  updateStorage();
  if (sessionContext.session) {
    saveProfile({ data: getProfileObject(), context: { sessionContext } });
  }
};

const ensureProfileLoaded = () => {
  if (profile) {
    return;
  }
  if (isBrowser()) {
    const rawJsonProfile = JSON.parse(localStorage.getItem("profile")) || {};
    receiveEmail = rawJsonProfile.receive_email;
    profile = {
      followed: new Set(rawJsonProfile.followed),
    };
  } else {
    profile = {};
  }
};

export const getIsReceivingEmails = () => {
  ensureProfileLoaded();
  return receiveEmail;
};

export const getFollowed = () => {
  ensureProfileLoaded();
  const { followed = new Set() } = profile;
  return followed;
};

const getProfileObject = () => {
  return {
    followed: Array.from(getFollowed()),
    receive_email: receiveEmail,
  };
};

const getProfileAsJson = () => {
  return JSON.stringify({
    followed: Array.from(getFollowed()),
    receive_email: receiveEmail,
  });
};

const updateStorage = () => {
  if (!isBrowser()) {
    return;
  }
  localStorage.setItem("profile", getProfileAsJson());
};

export const isFollowed = (exchange, symbol) => {
  const exchangeSymbol = `${exchange.toUpperCase()}_${symbol.toUpperCase()}`;
  return getFollowed().has(exchangeSymbol);
};

const saveAndUpdateServerFollowed = (newFollowed, sessionContext = {}) => {
  profile.followed = newFollowed;
  log.debug("Profile:", profile, sessionContext);
  updateStorage();
  if (sessionContext.session) {
    saveProfile({ data: getProfileObject(), context: { sessionContext } });
  }
};

export const updateFollowed = (exchange, symbol, _followed, sessionContext = {}) => {
  const exchangeSymbol = `${exchange.toUpperCase()}_${symbol.toUpperCase()}`;
  const newFollowed = new Set(getFollowed());
  if (_followed) {
    newFollowed.add(exchangeSymbol);
  } else {
    newFollowed.delete(exchangeSymbol);
  }
  saveAndUpdateServerFollowed(newFollowed, sessionContext);
};


function eqSet(as, bs) {
  if (as.size !== bs.size) return false;
  for (var a of as) if (!bs.has(a)) return false;
  return true;
}

// TODO: When syncing from server, do we need to save to local storage?
export const syncProfile = (params) => {
  log.debug("syncProfile() params:", params);
  getProfile(params)
    .then(response => {
      const { receive_email } = response;
      receiveEmail = receive_email;
      log.debug("Profile response:", response);
      const serverFollowed = new Set(response.followed);
      const localFollowed = getFollowed();
      if (!eqSet(serverFollowed, localFollowed)) {
        log.debug("Server and local followed are out of sync, updating server...");
        const mergedFollowed = new Set();
        serverFollowed.forEach(sf => mergedFollowed.add(sf));
        localFollowed.forEach(lf => mergedFollowed.add(lf));
        // TODO: If local version has removed company, should it be removed from server?
        const { context = {} } = params;
        saveAndUpdateServerFollowed(mergedFollowed, context.sessionContext);
      } else {
        log.debug("Server and local followed are in sync, no server call needed.");
      }
    })
    .catch(err => {
      log.error("Error getting profile from server:", err);
    });
};
